// extracted by mini-css-extract-plugin
module.exports = {"main":"Img_main__LIcad"};